import { Dialog } from '@angular/cdk/dialog';
import { inject } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { IDialogResponse } from '../../components/dialogs/dialog';
import { ResetChangesLeaveSiteDialogComponent } from '../../components/dialogs/reset-changes-leave-site-dialog/reset-changes-leave-site-dialog.component';
import { CmsTextProviderService } from '../../services/cms-text-provider.service';

export class FormChangedGuard {
  private readonly dialog: Dialog = inject(Dialog);
  private readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
  public async handleNavigation(
    hasUnsavedChanges: boolean,
    url: string,
    tapFunction?: () => void,
    saveFunction?: () => void | boolean | Promise<void | boolean>,
    headline: string = this.cmsTextProvider.shared.revertChanges
  ): Promise<boolean> {
    if (hasUnsavedChanges || url.includes('error')) {
      const dialogRef = this.dialog.open<IDialogResponse<boolean>>(
        ResetChangesLeaveSiteDialogComponent,
        {
          data: {
            headline,
            width: '600px',
            icon: 'warning',
            iconBackgroundColor: '#eed202',
          },
        }
      );
      return await firstValueFrom(
        dialogRef.closed.pipe(
          map(async result => {
            if (result?.submit && result.acceptChanges && saveFunction) {
              const saved = await saveFunction();
              return saved === true;
            }

            if (result?.submit) {
              if (tapFunction) {
                tapFunction();
              }
              return true;
            }
            return false;
          })
        )
      );
    }
    return true;
  }
}
